import React from 'react';
import { PageIntro } from '../components/PageIntro';
import { FinalCta } from '../components/FinalCta';
import { LandingKey, landingPages } from '../data/landing';
import { AutoGlassRepair } from '../landing/pages/AutoGlassRepair/AutoGlassRepair';
import { ResidentialGlass } from '../landing/pages/ResidentialGlass/ResidentialGlass';
import { ShowerDoors } from '../landing/pages/ShowerDoors/ShowerDoors';
import { CommercialGlass } from '../landing/pages/CommercialGlass/CommercialGlass';
import { EmergencyAutoGlass } from '../landing/pages/EmergencyAutoGlass/EmergencyAutoGlass';
const bodies = {
  auto: AutoGlassRepair,
  residential: ResidentialGlass,
  shower: ShowerDoors,
  commercial: CommercialGlass,
  emergency: EmergencyAutoGlass
};
export function LandingPage({
  page
}: {
  page: LandingKey;
}) {
  const Body = bodies[page];
  return <div className="landing-page" data-id="element-1640" data-mp="qlikofhnt4tx"><PageIntro data={landingPages[page]} id={page} urgent={page === 'emergency'} data-id="element-1641" data-mp="qmtnabzdc6jg" /><Body data-id="element-1642" data-mp="ln7ag3ngcsb6" /><FinalCta data-id="element-1643" data-mp="lnh17tgbn3hx" /></div>;
}